import React from 'react';
import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import logoIcon from '../assets/concreto_tec_logo.png';
import { LogoRelatorio, AssinaturasRodape } from './pdf/PersonalizacaoRelatorio';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 8,
    padding: 24,
  },
  // Capa
  coverPage: {
    fontFamily: 'Helvetica',
    padding: 48,
  },
  coverBrandRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  coverIcon: {
    width: 48,
    height: 48,
  },
  coverBrandText: {
    marginLeft: 14,
  },
  coverWordmark: {
    fontSize: 18,
    fontFamily: 'Helvetica-Bold',
  },
  coverTagline: {
    fontSize: 8,
    letterSpacing: 1,
    color: '#0e7490',
    marginTop: 2,
  },
  coverSpacer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  coverTitleBlock: {
    paddingTop: 40,
    borderTop: '1.5pt solid #000',
  },
  coverKicker: {
    fontSize: 9,
    letterSpacing: 1,
    color: '#666',
    marginBottom: 8,
  },
  coverTitle: {
    fontSize: 20,
    fontFamily: 'Helvetica-Bold',
    lineHeight: 1.25,
  },
  coverSubtitle: {
    fontSize: 10,
    color: '#666',
    marginTop: 6,
  },
  coverMetaGrid: {
    marginTop: 28,
  },
  coverMetaField: {
    marginBottom: 14,
  },
  coverMetaLabel: {
    fontSize: 7,
    letterSpacing: 0.5,
    color: '#888',
    marginBottom: 3,
  },
  coverMetaValue: {
    fontSize: 10,
    borderBottom: '0.75pt solid #ccc',
    paddingBottom: 5,
  },
  coverFooter: {
    paddingTop: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
    color: '#888',
  },
  headerBox: {
    border: '1pt solid #000',
    marginBottom: 4,
  },
  headerTop: {
    flexDirection: 'row',
    borderBottom: '1pt solid #000',
  },
  headerTitleBlock: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
    borderRight: '1pt solid #000',
  },
  headerTitle: {
    fontSize: 11,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
  },
  headerSubtitle: {
    fontSize: 9,
    textAlign: 'center',
    marginTop: 2,
  },
  headerLogoBlock: {
    width: 100,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 6,
  },
  logoPlaceholder: {
    width: 80,
    height: 48,
    border: '0.75pt dashed #999',
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholderText: {
    fontSize: 5,
    color: '#888',
    textAlign: 'center',
  },
  headerLower: {
    flexDirection: 'row',
  },
  headerLowerLeft: {
    flex: 1,
    flexDirection: 'column',
  },
  headerIdBarRow: {
    flexDirection: 'row',
    borderBottom: '1pt solid #000',
  },
  headerIdBar: {
    flex: 1,
    backgroundColor: '#000',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4 8',
  },
  headerIdBarLabel: {
    color: '#fff',
    fontSize: 8,
    fontFamily: 'Helvetica-Bold',
    letterSpacing: 1,
  },
  headerLogoFill: {
    width: 100,
    borderLeft: '1pt solid #000',
  },
  headerMeta: {
    flexDirection: 'row',
    borderBottom: '1pt solid #000',
  },
  metaCell: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4 6',
    borderRight: '1pt solid #000',
    minWidth: 0,
  },
  metaCellLast: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4 6',
    minWidth: 0,
  },
  metaColData: { flex: 0.8 },
  metaColEmpresas: { flex: 1.5 },
  metaColObras: { flex: 1.5 },
  metaColCps: { flex: 0.6 },
  metaLabel: {
    fontFamily: 'Helvetica-Bold',
    marginRight: 4,
    flexShrink: 0,
  },
  metaValue: {
    flexShrink: 1,
  },
  noticeRow: {
    padding: '3 6',
    alignItems: 'center',
  },
  noticeText: {
    fontSize: 7,
    textAlign: 'center',
    color: '#333',
  },
  table: {
    border: '1pt solid #000',
    marginTop: 6,
  },
  tableRow: {
    flexDirection: 'row',
    borderTop: '1pt solid #000',
    borderBottom: '1pt solid #000',
  },
  tableRowLast: {
    flexDirection: 'row',
    borderTop: '1pt solid #000',
  },
  tableRowEven: {
    backgroundColor: '#f5f5f5',
  },
  th: {
    fontFamily: 'Helvetica-Bold',
    padding: '4 4',
    borderRight: '1pt solid #000',
    textAlign: 'center',
  },
  thLast: {
    fontFamily: 'Helvetica-Bold',
    padding: '4 4',
    textAlign: 'center',
  },
  td: {
    padding: '5 4',
    borderRight: '1pt solid #000',
    textAlign: 'center',
  },
  tdLast: {
    padding: '5 4',
    textAlign: 'left',
  },
  colId: { width: '14%' },
  colIdade: { width: '7%' },
  colMoldagem: { width: '10%' },
  colObra: { width: '13%' },
  colCarga: { width: '10%' },
  colTipoRuptura: { width: '10%' },
  colCargaEsperada: { width: '12%' },
  colObs: { flex: 1 },
  signatureFooter: {
    marginTop: 16,
  },
  footer: {
    marginTop: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 7,
    color: '#666',
  },
});

// Exibe a data no padrão brasileiro (dd/mm/aaaa) para uso dentro do PDF.
function formatDateBrPdf(value) {
  if (!value) return '-';
  const s = String(value);
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s;
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-');
    return `${d}/${m}/${y}`;
  }
  const p = new Date(s);
  if (Number.isNaN(p.getTime())) return s;
  return p.toLocaleDateString('pt-BR');
}

// Exibe um número com 2 casas decimais no PDF, ou '-' se ausente/inválido.
function formatNumeroPdf(value) {
  if (value == null || !Number.isFinite(Number(value))) return '-';
  return Number(value).toFixed(2);
}

// Calcula, para cada item, a faixa de cor (0 ou 1) a partir do grupo de irmãos.
// Grupo de irmãos = mesmo caminhão + mesma idade de ruptura + mesmo tipo de CP.
// A faixa só alterna quando o grupo muda, então irmãos ficam sempre na mesma cor e
// CPs sem irmãos continuam alternando normalmente entre si, como no zebra por linha.
function calcularFaixasComIrmaos(resultados) {
  let faixaAtual = 0;
  let grupoAnteriorKey = null;

  return resultados.map((item) => {
    const key = `${item.idCaminhao ?? '-'}|${item.idadeRuptura ?? '-'}|${item.idTipoCorpoProva ?? '-'}`;
    if (key !== grupoAnteriorKey) {
      faixaAtual = faixaAtual === 0 ? 1 : 0;
      grupoAnteriorKey = key;
    }
    return { ...item, faixa: faixaAtual };
  });
}

// Texto de aviso do cabeçalho: uso interno e orientação de procedimento em caso de carga abaixo da esperada.
// O nome do cliente é interpolado a partir das empresas selecionadas no relatório.
function montarTextoAviso(empresas = []) {
  const nomeCliente = empresas.filter(Boolean).join(', ') || '[Cliente]';
  return (
    `Este documento é para uso interno da ${nomeCliente}. Sua divulgação... ` +
    'o corpo de prova "irmão" sem expressa autorização da Engenharia.'
  );
}

// Documento PDF (@react-pdf) da Ficha de Ruptura (NBR 5739): cabeçalho com empresas/obras e tabela de resultados.
function FichaRupturaPDF({
  dataRuptura,
  resultados,
  empresas = [],
  obras = [],
  logoCliente = null,
  assinaturas = [],
}) {
  const textoAviso = montarTextoAviso(empresas);

  return (
    <Document>
      {/* Capa */}
      <Page size="A4" style={styles.coverPage}>
        <View style={styles.coverBrandRow}>
          <Image style={styles.coverIcon} src={logoIcon} />
          <View style={styles.coverBrandText}>
            <Text style={styles.coverWordmark}>concreto.tec.br</Text>
            <Text style={styles.coverTagline}>TECNOLOGIA EM CONCRETO</Text>
          </View>
        </View>

        <View style={styles.coverSpacer}>
          <View style={styles.coverTitleBlock}>
            <Text style={styles.coverKicker}>FICHA DE RUPTURA</Text>
            <Text style={styles.coverTitle}>Ficha de Ruptura de Corpos de Prova</Text>
            <Text style={styles.coverSubtitle}>NBR 5739:2019</Text>

            <View style={styles.coverMetaGrid}>
              <View style={styles.coverMetaField}>
                <Text style={styles.coverMetaLabel}>EMPRESAS</Text>
                <Text style={styles.coverMetaValue}>{empresas.join(', ') || '-'}</Text>
              </View>
              <View style={styles.coverMetaField}>
                <Text style={styles.coverMetaLabel}>OBRAS</Text>
                <Text style={styles.coverMetaValue}>{obras.join(', ') || '-'}</Text>
              </View>
              <View style={styles.coverMetaField}>
                <Text style={styles.coverMetaLabel}>DATA DE EMISSÃO</Text>
                <Text style={styles.coverMetaValue}>{formatDateBrPdf(new Date())}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.coverFooter}>
          <Text>concreto.tec.br</Text>
          <Text>Documento gerado eletronicamente</Text>
        </View>
      </Page>

      <Page size="A4" orientation="landscape" style={styles.page}>
        {/* Cabeçalho */}
        <View style={styles.headerBox}>
          <View style={styles.headerTop}>
            <View style={styles.headerTitleBlock}>
              <Text style={styles.headerTitle}>FICHA DE RUPTURA DE CORPOS DE PROVA</Text>
              <Text style={styles.headerSubtitle}>NBR 5739:2019</Text>
            </View>
            
            <View style={styles.headerLogoBlock}>
              <LogoRelatorio src={logoCliente} width={90} height={48} />
            </View>
          </View>

          <View style={styles.headerLower}>
            <View style={styles.headerLowerLeft}>
              <View style={styles.headerIdBarRow}>
                <View style={styles.headerIdBar}>
                  <Text style={styles.headerIdBarLabel}>IDENTIFICAÇÃO DO RELATÓRIO</Text>
                </View>
                <View style={styles.headerLogoFill} />
              </View>
            </View>
          </View>

          <View style={styles.headerMeta}>
            <View style={[styles.metaCell, styles.metaColData]}>
              <Text style={styles.metaLabel}>Data de Ruptura</Text>
              <Text style={styles.metaValue}>{dataRuptura || '-'}</Text>
            </View>
            <View style={[styles.metaCell, styles.metaColEmpresas]}>
              <Text style={styles.metaLabel}>Empresas</Text>
              <Text style={styles.metaValue}>{empresas.join(', ') || '-'}</Text>
            </View>
            <View style={[styles.metaCell, styles.metaColObras]}>
              <Text style={styles.metaLabel}>Obras</Text>
              <Text style={styles.metaValue}>{obras.join(', ') || '-'}</Text>
            </View>
            <View style={[styles.metaCellLast, styles.metaColCps]}>
              <Text style={styles.metaLabel}>CPs para Romper</Text>
              <Text style={styles.metaValue}>{resultados.length}</Text>
            </View>
          </View>

          <View style={styles.noticeRow}>
            <Text style={styles.noticeText}>{textoAviso}</Text>
          </View>
        </View>

        {/* Tabela */}
        <View style={styles.table}>
          {/* Cabeçalho da tabela */}
          <View style={styles.tableRow}>
            <Text style={[styles.th, styles.colId]}>Identificador{'\n'}(ID - Etiqueta)</Text>
            <Text style={[styles.th, styles.colIdade]}>Idade{'\n'}(Dias)</Text>
            <Text style={[styles.th, styles.colMoldagem]}>Data de{'\n'}Moldagem</Text>
            <Text style={[styles.th, styles.colObra]}>Obra</Text>
            <Text style={[styles.th, styles.colCarga]}>Carga</Text>
            <Text style={[styles.th, styles.colTipoRuptura]}>Tipo de{'\n'}Ruptura</Text>
            <Text style={[styles.th, styles.colCargaEsperada]}>Carga{'\n'}Esperada</Text>
            <Text style={[styles.thLast, styles.colObs]}>Observações</Text>
          </View>

          {/* Linhas de dados */}
          {calcularFaixasComIrmaos(resultados).map((item, index) => {
            const isLast = index === resultados.length - 1;
            const isEven = item.faixa === 1;
            const rowStyle = [
              isLast ? styles.tableRowLast : styles.tableRow,
              isEven ? styles.tableRowEven : null,
            ];

            return (
              <View key={item.id || index} style={rowStyle}>
                <Text style={[styles.td, styles.colId]}>{item.etiqueta || '-'}</Text>
                <Text style={[styles.td, styles.colIdade]}>
                  {item.idadeRuptura !== '' && item.idadeRuptura != null ? String(item.idadeRuptura) : ''}
                </Text>
                <Text style={[styles.td, styles.colMoldagem]}>
                  {item.dataMoldagem ? formatDateBrPdf(item.dataMoldagem) : ''}
                </Text>
                <Text style={[styles.td, styles.colObra]}>{item.obra || '-'}</Text>
                <Text style={[styles.td, styles.colCarga]}>{/* em branco: preenchimento manual */}</Text>
                <Text style={[styles.td, styles.colTipoRuptura]}>{/* em branco: preenchimento manual */}</Text>
                <Text style={[styles.td, styles.colCargaEsperada]}>{formatNumeroPdf(item.tensaoEsperada)}</Text>
                <Text style={[styles.tdLast, styles.colObs]}>{/* em branco: preenchimento manual */}</Text>
              </View>
            );
          })}
        </View>

        {/* Rodapé */}
        <View style={styles.signatureFooter} wrap={false}>
          <AssinaturasRodape assinaturas={assinaturas} />
        </View>
        <View style={styles.footer}>
          <Text style={styles.footerText}>Emitido em: {formatDateBrPdf(new Date())}</Text>
          <Text
            style={styles.footerText}
            render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
          />
        </View>
      </Page>
    </Document>
  );
}

export default FichaRupturaPDF;
